import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { AuthService, SearchService, SettingsService } from '@gallaghercp/core-frontend';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

@Component({
    selector: 'core-client-search-form',
    templateUrl: './search-form.component.html',
    standalone: false,
})
export class SearchFormComponent implements OnInit, OnDestroy {
    search = inject(SearchService);
    settings = inject(SettingsService);
    protected auth = inject(AuthService);
    protected router = inject(Router);
    protected breakpoint = inject(BreakpointObserver);

    @Output() closeSidenavHamburgerNav = new EventEmitter<boolean>();
    @Output() closeTopnavHamburgerNav = new EventEmitter<boolean>();
    @Input() autoFocus?: boolean = false;

    queryField: FormControl = new FormControl(this.search.query$.getValue());
    subscription: Subscription = new Subscription();

    ngOnInit() {
        this.subscription.add(
            this.queryField.valueChanges.pipe(debounceTime(800), distinctUntilChanged()).subscribe(term => {
                if (term && term.length > 2) {
                    this.search.isSearchModalSearching(true);
                    this.search.setQuery(term);
                }
                if (term && term.length > 0) {
                    this.search.showClearButton = true;
                }
                if (term == '') {
                    this.search.showClearButton = false;
                    this.resetSearch();
                    this.search.isSearchModalLoading(false);
                    this.search.isSearchModalSearching(false);
                }
            }),
        );
        this.subscription.add(
            this.search.query$.subscribe((query: string) => {
                this.queryField.setValue(query);
            }),
        );
    }

    // performSearch() {
    //     this.closeSidenavHamburgerNav.emit(false);
    //     this.closeTopnavHamburgerNav.emit(false);
    //
    //     this.breakpointSubscription = this.breakpoint.observe([
    //         '(max-width: 991px)'
    //     ]).subscribe(result => {
    //         if (result.matches) {
    //             document.body.style.overflowY = 'revert';
    //             this.router.navigate(['/search']);
    //         }
    //     });
    //
    //     return this.search.performSearch();
    // }

    resetSearch() {
        this.search.reset();
        this.queryField.reset();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
